import NotNullCheck from "../util/NotNullCheck";
import {rnd} from "../util/Validation";

export const userRegisterModel = {
    name: null,
    surname: null,
    gender: null,
    nationality: null,
    identityCardNo: null,
    birthdate: null,
    areaCode: null,
    mobileNumber: null,
    email: null,
    passcode: null,
    repeatPasscode: null,
    rightsMiles: false,
    rightsTurkishAirlines: false,
    rightsGDPR: false
}

export const validation = (user, t) => {
    const valid = {
        name: (user.name == null || !user.name) ? t('error.empty_name') : null,
        surname: (user.surname == null || !user.surname) ? t('error.empty_surname') : null,
        gender: (user.gender == null || !user.gender) ? t('error.empty_gender') : null,
        nationality: (user.nationality == null || !user.nationality) ? t('error.empty_nationality') : null,
        identityCardNo: user.nationality?.value !== 'TR' ? null : (user.identityCardNo == null || !user.identityCardNo) ? t('error.empty_identity_card_no') : null,
        birthdate: (user.birthdate == null || !user.birthdate || user.birthdate.replaceAll("_", "").length !== 10) ? t('error.empty_birthdate') : null,
        areaCode: (user.areaCode == null || !user.areaCode) ? t('error.empty_area_code') : null,
        mobileNumber: (user.mobileNumber == null || !user.mobileNumber) ? t('error.empty_mobile_number') : null,
        email: (user.email == null || !user.email) ? t('error.empty_email') : (!checkEmail(user.email) ? t('error.empty_mail_payment_format') : null),
        passcode: (user.passcode == null || !user.passcode) ? rnd(t('error.empty_password_alternative')) : null,
        repeatPasscode: (user.repeatPasscode == null || !user.repeatPasscode) ? rnd(t('error.empty_password_repeat')) : null,
        rightsMiles: (user.rightsMiles == null || !user.rightsMiles) ? rnd(t('error.empty_approve')) : null,
        rightsTurkishAirlines: (user.rightsTurkishAirlines == null || !user.rightsTurkishAirlines) ? rnd(t('error.empty_approve')) : null,
        rightsGDPR: (user.rightsGDPR == null || !user.rightsGDPR) ? rnd(t('error.empty_approve')) : null,
    }
    if (user.passcode?.toString()?.length !== 6) {
        valid.passcode = rnd(t('error.empty_password_six'));
    }
    if (user.passcode !== user.repeatPasscode) {
        valid.repeatPasscode = rnd(t('error.empty_password_match'));
    } else {
        valid.repeatPasscode = null;
    }
    valid.error = !NotNullCheck(valid);
    return valid;
}

export const checkEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
}

